import { createSlice } from "@reduxjs/toolkit";
import { BrandListSlice } from "types/brand";
import { fetchBrandList } from "./thunk";
import { ERROR } from "types";


const initialState: BrandListSlice = {
    count: 0,
    is_owner: false,
    items: [],
    brands: [],
    loading: false,
    page: 1,
    last_fetched_at: null,
    has_more: true,
    expired: true,
    error: null
}

const brandListSlice = createSlice({
    name: 'brandsList',
    initialState,
    reducers: {
        markBrandListExpired: (state) => {
            state.expired = true;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBrandList.pending, (state) => {
                state.loading = true;
                state.error = null
            })
            .addCase(fetchBrandList.fulfilled, (state, action) => {
                state.items = action.payload.page === 1 ?
                    action.payload.brandList.items :
                    [...state.items, ...action.payload.brandList.items];

                state.count = action.payload.brandList.count;
                state.page = action.payload.page;
                state.loading = false;
                state.has_more = action.payload.brandList.count > state.items.length;
                state.last_fetched_at = Date.now();
                state.expired = false;
            })
            .addCase(fetchBrandList.rejected, (state, action) => {
                state.loading = false;
                if(action.payload !== ERROR.CACHED){
                    state.error = action.payload || 'Failed to fetch brands'
                }
            })
    }
})

export const { markBrandListExpired } = brandListSlice.actions;

export default brandListSlice.reducer;